const useIsLoadedInsideIframe = () => {
  return window.location !== window.parent.location;
};

export default useIsLoadedInsideIframe;
